<template>
  <div class="edit-down-table">
    <vxe-pulldown class="edit-down-pulldown" ref="xDown" transfer>
      <template>
        <vxe-input size="mini" ref="vxeInput" class="edit-down-input" placeholder="输入关键词筛选" 
        v-model="row[column.property]" 
        suffix-icon="el-icon-caret-bottom" 
        @keyup="keyupEvent" 
        @click="clickEvent" 
        @suffix-click="suffixClick"></vxe-input>
      </template>
      <template #dropdown>
        <div class="edit-down-wrapper">
          <vxe-grid
            ref="vxeGrid"
            highlight-hover-row
            highlight-current-row
            auto-resize
            size="small"
            height="auto"
            :loading="loading"
            :pager-config="tablePage"
            :data="tableData"
            :columns="tableColumn"
            @cell-dblclick="doubleEvent"
            @cell-click="selectEvent"
            @page-change="pageChangeEvent"
            @keydown="keydownEvent"
            :keyboard-config="{isArrow: true}">
          </vxe-grid>
        </div>
      </template>
    </vxe-pulldown>
  </div>
</template>

<script>
import request from "../../utils/request"

export default {
  name: 'EditDownTable',
  props: {
    requestUrl: '',
    columnData: Array,
    parent: Object, // 暂未使用
    params: Object
    
  },
  data () {
    return {
      row: null,
      column: null,
      loading: false,
      tableData: [],
      tableColumn: [],
      fetchTableData: [],
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 50, 100]
      }
    }
  },
  created () {
    this.load()
  },
  mounted() {
    this.keyupEvent = _.debounce(this.keyupEvent, 300);
  },
  methods: {
    load () {
      if(this.columnData.length>0) this.tableColumn = this.columnData
      const { row, column } = this.params
      this.row = row
      this.column = column
      // this.fetchData().then(data => {
      //   this.tableData = data
      // })
    },
    async fetchData() {
      await request({
        url: this.requestUrl,
        method: "post",
        params: {
          keyword: this.row[this.column.property],
          pageSize: this.tablePage.pageSize,
          page: this.tablePage.currentPage
        },
      })
      .then((res) => {
        if (res.code == 200) {
          this.fetchTableData = res.data.list
          this.tablePage.total = res.data.count
        }
      })
      .catch((err) => {});
      
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(this.fetchTableData)
        }, 0)
      })
    },
    clickEvent () {
      if(this.tableData.length<1) {
        this.fetchData().then(data => {
          this.tableData = data
        })
      }
      
      this.$refs.xDown.showPanel()
    },
    keyupEvent (params) {
      // console.log('输入框键盘事件：', params)      

      // 键盘切换焦点 选中表格数据第一行
      const { $event, value } = params
      
      const { row, column } = this
      const cellValue = row[column.property]

      if($event.keyCode == 40 || $event.keyCode == 13 || $event.keyCode == 38) { // ArrowDown 下箭头 ， Enter 回车 ， ArrowUp 上箭头
        this.$refs.vxeInput.blur()
        setTimeout(()=>{
          this.$refs.vxeGrid.focus()
          if(!this.$refs.vxeGrid.getCurrentRecord()) this.$refs.vxeGrid.setCurrentRow(this.tableData[0])
        }, 0)
        return
      }

      this.loading = true
      this.fetchData().then(data => {
        this.loading = false
        this.$refs.xDown.showPanel()
        // if (cellValue) {
        //   this.tableData = data.filter(item => item.name.indexOf(cellValue) > -1)
        // } else {
          this.tableData = data
        // }
        
      })
    },
    suffixClick () {
      this.$refs.xDown.togglePanel()
    },
    pageChangeEvent ({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.loading = true
      this.fetchData().then(data => {
        this.loading = false
        this.tableData = data
      })
    },
    keydownEvent(params) {
      // console.log('keydownEvent: ', params)
      const { $event, $grid } = params
      if($event.keyCode == 27) { // Escape 取消
        this.$refs.xDown.hidePanel()
      }
      if($event.keyCode == 13) {
        const { row, column } = this
        const currRow = $grid.getCurrentRecord()
        row[column.property] = currRow[column.property]
        this.$refs.xDown.hidePanel()
      }
    },
    doubleEvent (params) {
      const { row, column } = this
      row[column.property] = params.row[column.property]
      // 更新原始row数据
      this.tableColumn.forEach(item=>{
        if(item.type != 'seq' && item.field) {
         
             row[item.field] = params.row[item.field]
       
        }
      })
      
      this.$refs.xDown.hidePanel()
      // 触发父表格更新
      this.params.$table.updateStatus({ row, column })
    },
    selectEvent (params) {
      // console.log('单击: ', params)
      // const { row, column } = this
      // row[column.property] = params.row.name
      // this.$refs.xDown.hidePanel()
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-down-pulldown {
  width: 100%;
}
.edit-down-wrapper {
  width: 600px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
}
</style>